function sharedReducer(state = {}, action) {
  switch (action.type) {
    case 'SHOW_MODAL':
      return {
        ...state,
        [action.modalName]: {
          ...state[action.modalName],
          show: true,
          data: action.data,
        },
      };
    case 'HIDE_MODAL':
      return {
        ...state,
        [action.modalName]: {
          ...state[action.modalName],
          show: false,
          data: null,
        },
      };
    default:
      return state;
  }
}

export default sharedReducer;
